import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../../_base/crud';
// State
import { AppState } from '../../../reducers';
import { selectVehicleInStore, selectVehiclePageLoading, selectVehicleShowInitWaitingMessage } from '../_selectors/vehicle.selectors';

export class VehicleDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectVehiclePageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectVehicleShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectVehicleInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
